import { request } from "../../Services/Api"

const BASE = "/admin_panel/payment-matching/"

/**
 * Serialise params, repeating a key once per value instead of joining with commas.
 *
 * Raw payment-method values are shown verbatim and at least one of them contains a comma
 * ("buy now, pay later & cashapp"), so a comma-joined list is ambiguous. The shared axios client has
 * no paramsSerializer, and its default would emit "key[]=" — which the backend does not read — so the
 * query string is built here rather than by changing the client for every other endpoint.
 */
const buildQuery = (params = {}) => {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return

    if (Array.isArray(value)) {
      value.forEach((item) => query.append(key, item))
      return
    }

    query.append(key, value)
  })

  return query.toString()
}

export const getPaymentMatching = (params) => request.api.get(`${BASE}?${buildQuery(params)}`)

export const getPaymentMatchingSummary = () => request.api.get(`${BASE}summary/`)

export const getPaymentMatchingFilterOptions = () => request.api.get(`${BASE}filter-options/`)

/** Describe the group a candidate name would produce, so a confirmation can name every row it reaches. */
export const getPaymentMatchingGroup = ({ id, ui_name }) =>
  request.api.get(`${BASE}${id}/group/?${buildQuery({ ui_name })}`)

/** Save a UI name. Answers 409 with the conflict dialog's contents when an icon choice is needed. */
export const renamePaymentMatching = ({ id, ui_name, icon_choice }) =>
  request.api.patch(`${BASE}${id}/ui-name/`, {
    ui_name,
    ...(icon_choice ? { icon_choice } : {})
  })

export const setPaymentMatchingIcon = ({ id, icon_id }) =>
  request.api.put(`${BASE}${id}/icon/`, { icon_id })

export const uploadPaymentMatchingIcon = ({ id, formData }) =>
  request.api.post(`${BASE}${id}/icon/`, formData)

export const deletePaymentMatchingIcon = ({ id }) => request.api.delete(`${BASE}${id}/icon/`)

export const getPaymentMatchingIcons = () => request.api.get(`${BASE}icons/`)

/** Activity log. Without an id the log covers the whole page; with one it is scoped to that value. */
export const getPaymentMatchingLogs = ({ id, ...params }) =>
  request.api.get(`${BASE}${id ? `${id}/` : ""}logs/?${buildQuery(params)}`)

/** Every admin in the system, for the log's User filter — a directory, not a list built from records. */
export const getPaymentMatchingLogUsers = () => request.api.get(`${BASE}log-users/`)
